module.exports = __webpack_public_path__ + "static/media/home-grey.b530fe9f.png";